
import { useStore } from '@/store'
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import * as RenderingConstants from '@/constants/rendering-constants'
import RenderingPathService from '@/services/rendering/rendering-path.service'
import edgeSettings from '@/settings/edge-settings.json'
import threadSettings from '@/settings/thread-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselEdge',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configEdgeId = computed(() => store.getters.configEdgeId)
    const configThreadId = computed(() => store.getters.configThreadId)
    const configFrontId = computed(() => store.getters.configFrontId)
    let imagePath = ref('')
    let renderPathService = new RenderingPathService()

    emitter.on('updateConfig', updateRendering)

    // prettier-ignore
    watch(() => configEdgeId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configThreadId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configFrontId.value, (_) => { updateRendering() })

    function updateRendering() {
      try {
        const edgeId = renderPathService.formatConfig(configEdgeId.value, edgeSettings.edgeColors)
        const threadId = renderPathService.formatConfig(configThreadId.value, threadSettings.threadColors)
        setRendering(edgeId, threadId)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setRendering(edgeId: string | null, threadId: string | null) {
      if (!edgeId || !threadId) {
        if (!threadId) {
          console.error('cannot find thread id for RenderingRandselEdge')
        }
        imagePath.value = ''
        return
      }
      const camPath = 'cam' + (props.cameraPos + 1) + '/'
      const optionPath = 'edge/' + getFrontPath() + threadId + '/' + edgeId + '.png'
      const path = RenderingConstants.path + camPath + optionPath
      console.log(path)
      imagePath.value = path
    }

    function getFrontPath() {
      if (configFrontId.value == "8") {
        return "futaRibbon/"
      } else if (configFrontId.value == "10") {
        return "futaRainbow/"
      }
      else {
        return "futaDefault/"
      }
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateRendering)
    })

    return {
      imagePath
    }
  }
})
